var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('ProductImageViewer',{attrs:{"images":_vm.productImages}})],1),_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"col-right"})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }